// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37prl","image":"Header_image__ybIPU","name":"Header_name__24JC-","info":"Header_info__1tn5W","infoRow":"Header_infoRow__2aj1U"};